const isSafeInternalUrl = (url?: string | null): url is string =>
	Boolean(url?.startsWith("/") && !url.startsWith("//"));

const LOGIN_PATH = "/investors/login";

export const getLogoutUrl = (returnUrl: string): string => {
	const target = new URL(LOGIN_PATH, window.location.origin);
	if (isSafeInternalUrl(returnUrl) && returnUrl.split("?")[0] !== LOGIN_PATH) {
		target.searchParams.set("url", returnUrl);
	}
	return target.toString();
};

export const redirectToLogin = (returnUrl: string): void => {
	const target = getLogoutUrl(returnUrl);
	if (window.location.href !== target) window.location.replace(target);
};

export const getSafeLogoutReturnUrl = (url?: string | null): string | undefined =>
	isSafeInternalUrl(url) ? url : undefined;
